import { defer, filter, map, merge, Observable, Subject } from 'rxjs';
import { WebcastService } from './Webcast.Service';

export type ReactionCount = { char: string, count: number };

/**
 * Handles showing reaction emojis right away locally, filtering the duplicate push message.
 */
export class WebcastReactions {
	private pendingReactions: { [ch: string]: number } = {};

	public readonly pendingReactionsSubject$ = new Subject<ReactionCount>();

	constructor(
		private readonly webcastId: string,
		private readonly WebcastService: WebcastService
	) { }

	public add(char: string): void {
		this.pendingReactions[char] = (this.pendingReactions[char] || 0) + 1;
		this.pendingReactionsSubject$.next({ char, count: 1 });
		this.WebcastService.addUserReaction(this.webcastId, char)
			.catch(e => console.error('Error adding emoji: ', e));
	}

	public getReactions$() {
		return merge(
			this.pendingReactionsSubject$,
			this.WebcastService.getUserReactions(this.webcastId)
				.pipe(
					map(e => {
						const pendingCount = this.pendingReactions[e.char] || 0;
						if(pendingCount > 0) {
							this.pendingReactions[e.char] = Math.max(pendingCount - e.count, 0);
						}
						return { char: e.char, count: e.count - pendingCount };
					}),
					filter(e => e.count > 0))
		);
	}
}
